import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function CTA() {
  return <section className="py-24 md:py-32 px-6 md:px-12" data-id="element-16">
      <div className="max-w-5xl mx-auto" data-id="element-17">
        <motion.div className="bg-navy-light border border-white/10 rounded-sm p-12 md:p-20 text-center relative overflow-hidden" initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-18">
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-amber/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none" data-id="element-19" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-amber/5 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2 pointer-events-none" data-id="element-20" />

          <div className="relative z-10" data-id="element-21">
            <h2 className="text-4xl md:text-6xl font-serif mb-6" data-id="element-22">
              Let's think this through.
            </h2>
            <p className="text-lg md:text-xl text-offwhite-muted font-light max-w-2xl mx-auto mb-10" data-id="element-23">
              Facing a complex decision? We'd love to hear about it. Schedule a
              conversation and let's explore how we can help your team move
              forward with clarity.
            </p>

            <div id="contact" className="flex justify-center" data-id="element-24">
              <a href="mailto:matt@mattdadvisory.com" className="group flex items-center justify-center gap-2 px-8 py-4 bg-amber text-navy font-medium rounded-sm hover:bg-amber-hover transition-all" data-id="element-25">
                Contact Us
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-26" />
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}